import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';
import { DEFAULT_STYLE_OPTIONS } from '../../../../../aumico-lib-annualreport-fe/src/lib';
import { OrganizationSettings } from '../../interfaces/organization-settings.interface';

@UntilDestroy()
@Component({
    selector: 'aumico-design-settings-page',
    templateUrl: './design-settings.page.html',
    styleUrls: ['./design-settings.page.scss'],
})
export class DesignSettingsPage implements OnInit, OnChanges {
    @Input() organizationSettings: OrganizationSettings | undefined;
    form: FormGroup;
    currentYearDate: Date;
    previousYearDate: Date;
    @Output() onSave = new EventEmitter<void>();

    constructor(private fb: FormBuilder) {
        const today = new Date();
        this.currentYearDate = today;
        this.previousYearDate = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate()); // Subtract one year
    }

    ngOnInit(): void {
        this.initializeForm();

        // React to form changes and emit the new values
        this.form.valueChanges.subscribe((value) => {
            // Don't modify the input - just emit the changes
            this.onOrganizationSettingsChanged.emit(value.styleOptions);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['organizationSettings'] && this.organizationSettings) {
            this.patchForm();
        }
    }

    initializeForm(): void {
        this.form = this.fb.group({
            styleOptions: this.fb.group({
                textColor: [this.organizationSettings?.textColor || DEFAULT_STYLE_OPTIONS.textColor],
                backgroundColor: [this.organizationSettings?.backgroundColor || DEFAULT_STYLE_OPTIONS.backgroundColor],
                backgroundColorPY: [this.organizationSettings?.backgroundColorPY || DEFAULT_STYLE_OPTIONS.backgroundColorPY],
                titleColor: [this.organizationSettings?.titleColor || DEFAULT_STYLE_OPTIONS.titleColor],
                tableHeaderColor: [
                    this.organizationSettings?.tableHeaderColor || DEFAULT_STYLE_OPTIONS.tableHeaderColor,
                ],
                tableFooterColor: [
                    this.organizationSettings?.tableFooterColor || DEFAULT_STYLE_OPTIONS.tableFooterColor,
                ],
            }),
        });
    }

    patchForm(): void {
        if (this.organizationSettings) {
            this.form?.patchValue({
                styleOptions: {
                    textColor: this.organizationSettings.textColor || DEFAULT_STYLE_OPTIONS.textColor,
                    backgroundColor: this.organizationSettings.backgroundColor || DEFAULT_STYLE_OPTIONS.backgroundColor,
                    backgroundColorPY: this.organizationSettings.backgroundColorPY || DEFAULT_STYLE_OPTIONS.backgroundColorPY,
                    titleColor: this.organizationSettings.titleColor || DEFAULT_STYLE_OPTIONS.titleColor,
                    tableHeaderColor:
                        this.organizationSettings.tableHeaderColor || DEFAULT_STYLE_OPTIONS.tableHeaderColor,
                    tableFooterColor:
                        this.organizationSettings.tableFooterColor || DEFAULT_STYLE_OPTIONS.tableFooterColor,
                },
            });
        }
    }

    save(): void {
        this.onSave.emit();
    }

    @Output() onOrganizationSettingsChanged = new EventEmitter<OrganizationSettings>();
}
